export enum NotificationChannelEnum {
  NOTIFICATION_CENTER = "notification_center",
  NOTIFICATION_MAIL = "mail",
  NOTIFICATION_SLACK = "slack",
  NOTIFICATION_SMS = "sms",
}
